<template>
    <div class="dialog1">
        <el-dialog 
            :title="dialog1.title" 
            :visible.sync="dialog1.show"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            :before-close="handleCloseDialog"
            width="30%">
            <div class="form">
                <el-form 
                    ref="form" 
                    :model="formData" 
                    :rules="formRules" 
                    label-width="120px" 
                    style="margin:10px;width:auto;"
                >
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证：" prop="idCard">
                        <el-input v-model="formData.idCard" placeholder="请输入18位身份证号"></el-input>
                    </el-form-item>
                    <el-form-item label="电话号码：" prop="phone">
                        <el-input v-model="formData.phone" placeholder="请输入11位手机号"></el-input>
                    </el-form-item>                   
                    <el-form-item label="系统角色：" prop="type">
                        <el-select v-model="formData.type" placeholder="请选择系统角色">
                            <el-option 
                                v-for="role in systemRoleList" 
                                :key="role.value" 
                                :label="role.label" 
                                :value="role.label"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="text-right">
                        <el-button @click="handleCancel">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import userApi from '@/api/user'

export default {
    name: 'UserAddDialog',
    props: {
        dialog1: {
            type: Object,
            required: true,
            default: function() { // Vue2 中默认值用函数（不能用箭头函数）
                return {
                    show: false,
                    title: ''
                }
            }
        }
    },
    data() {
        return {
            formData: {
                name: '',
                idCard: '',
                phone: '',
                type: ''
            },
            // 角色映射：label显示名，value对应后端数字值
            systemRoleList: [
                { label: '管理员', value: 1 },
                { label: '运营管理员', value: 2 },
                { label: '物业管理员', value: 3 },
                { label: '商住管理员', value: 4 }
            ],
            // 表单校验规则（Vue2 兼容版）
            formRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入合法的18位身份证号', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入合法的11位手机号', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择系统角色', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        // 角色名称转数字值（Vue2 兼容写法）
        getRoleValue(roleName) {
            // Vue2 中find方法兼容（ES6，需确保项目已配置babel）
            const role = this.systemRoleList.find(function(item) {
                return item.label === roleName;
            });
            return role ? role.value : '';
        },
        // 取消按钮逻辑（Vue2 兼容）
        handleCancel() {
            // Vue2 中避免可选链，用判断替代
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
            this.dialog1.show = false;
        },
        // 提交逻辑（Vue2 兼容版）
        handleSubmit() {
            this.$refs.form.validate(function(valid) { // Vue2 回调写法
                if (valid) {
                    const pojo = {
                        name: this.formData.name,
                        idCard: this.formData.idCard,
                        phone: this.formData.phone,
                        type: this.getRoleValue(this.formData.type) // 核心：角色转数字
                    };

                    // 加载动画（Element UI 兼容 Vue2）
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 接口调用（Vue2 Promise 写法）
                    userApi.addUser(pojo)
                        .then(function(res) {
                            loading.close();
                            if (res.data.flag) {
                                this.$message.success('添加成功');
                                this.$refs.form.resetFields();
                                this.dialog1.show = false;
                                this.$emit('update');
                            } else {
                                this.$message.warning('添加失败：' + (res.data.msg || '服务器处理异常'));
                            }
                        }.bind(this)) // Vue2 需绑定this，避免指向丢失
                        .catch(function(err) {
                            loading.close();
                            console.error('添加用户失败：', err);
                            this.$message.error('添加失败：网络异常，请稍后重试');
                        }.bind(this));
                }
            }.bind(this)); // 绑定this到validate回调
        },
        // 关闭弹窗前处理（Vue2 兼容）
        handleCloseDialog(done) {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
            done();
        }
    }
};
</script>

<style scoped>
/* Vue2 中scoped样式写法 */
.text-right {
    text-align: right;
}
.form {
    padding: 10px 0;
}
</style>